module.exports = __webpack_public_path__ + "img/agent1.7bfe64d0.png";